import * as Application from 'expo-application';
import Constants from 'expo-constants';
import * as Updates from 'expo-updates';
import { Platform } from 'react-native';

/**
 * Normalize getting app manifest attributes such as env, version, buildNumber,
 * and runtimeVersion. Expo EAS updates changes the way these attributes are
 * fetched post OTA update via `expo-updates` instead of `expo-constants`.
 */
class AppManifest {
  get env(): string {
    return (
      Updates?.manifest?.extra?.expoClient?.extra?.env ||
      Constants?.manifest2?.extra?.expoClient?.extra?.env ||
      Constants?.expoConfig?.extra?.env ||
      ''
    );
  }
  get version(): string {
    return (
      Updates?.manifest?.extra?.expoClient?.version ||
      Constants?.manifest2?.extra?.expoClient?.version ||
      Constants?.expoConfig?.version ||
      ''
    );
  }
  get buildNumber(): string {
    const manifestBuildNumber = getManifestBuildNumber();

    if (
      (Platform.OS === 'ios' || Platform.OS === 'android') &&
      Updates.isEmbeddedLaunch === false &&
      manifestBuildNumber
    ) {
      return manifestBuildNumber;
    }

    if (Platform.OS === 'ios' || Platform.OS === 'android') {
      const native = Application.nativeBuildVersion;
      if (native != null && native !== '') {
        return native;
      }
    }

    return manifestBuildNumber;
  }
  get runtimeVersion(): string {
    return (
      (Updates?.manifest?.runtimeVersion as string) ||
      (Constants?.manifest2?.runtimeVersion as string) ||
      (Constants?.expoConfig?.runtimeVersion as string) ||
      ''
    );
  }
}

function getManifestBuildNumber(): string {
  if (Platform.OS === 'ios') {
    return (
      Updates?.manifest?.extra?.expoClient?.ios?.buildNumber ||
      Constants?.manifest2?.extra?.expoClient?.ios?.buildNumber ||
      Constants?.expoConfig?.ios?.buildNumber ||
      ''
    );
  }
  if (Platform.OS === 'android') {
    const code =
      Updates?.manifest?.extra?.expoClient?.android?.versionCode ??
      Constants?.manifest2?.extra?.expoClient?.android?.versionCode ??
      Constants?.expoConfig?.android?.versionCode;
    return code != null && code !== '' ? String(code) : '';
  }
  return '';
}

export default new AppManifest();
